import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Unauthorized from '../Admin/Unauthorized';
import { setLoading } from './LoadingSlice';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import BaseUrl from "../../BaseUrl";
const headers = Unauthorized.Actionsauthorized();
const kycbaseurl = BaseUrl.authurl
const zoomurl=BaseUrl.conferenceurl
const initialState = {
    activeSection: 'profile',
    doctordetails:{},
    profile: { name: "", address: {}, dob: null, userName: "", email: "", phoneNumber: "", profilePic: null, gender: null, title: null, idproof: null, idprooftype: null,coutryCode:'',legalName:'' },
    education: [],
    specialization: [],
    payouts: { accountHolderName: '',accountNumber: '',confirmAccountNumber: '',ifsc: '',accountType: '',payoutType: '',swiftCode: ''},
    zoom: null,
    authoritymaster:[],
    isbankvalidated:false,
    iszoomauthvalidated:false
};

export const getDoctorDetails = createAsyncThunk(
    'kyc/getDoctorDetails',
    async (doctorId, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.get(`${kycbaseurl}Auth/GetDoctor?id=${doctorId}`);
            
            return response.data;
        } catch (error) {
            // Pass the status code in the rejected value for component-level handling
            return rejectWithValue({ 
                status: error.response?.status, 
                data: error.response?.data || 'Error fetching details' 
            });
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const getAuthorities = createAsyncThunk(
    'kyc/getAuthorities', 
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            const response = await axios.get(`${kycbaseurl}Kyc/GetIssuingAuthorities`, { headers }); // Ensure this endpoint is correct
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error fetching authorities');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const updateEmail = createAsyncThunk(
    'kyc/updateEmail', 
    async ({ phone, accesstoken, newemail }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.patch(`${kycbaseurl}Auth/UpdateEmail?PhoneNumber=${phone}&AccessToken=${accesstoken}&NewEmail=${newemail}&UserType=Doctor`);
            
            return response.data;
        } catch (error) {
            
            return rejectWithValue(error.response?.data || 'Error updating email');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const verifyemailotp = createAsyncThunk(
    'kyc/verifyemailotp', 
    async (data, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            

            const response = await axios.post(
                `${kycbaseurl}Auth/VerifyToken?UserType=Doctor`,
                data, 
                {
                    headers: {
                        'Content-Type': 'application/json', 
                    },
                }
            );

            
            return response.data;
        } catch (error) {
            
            return rejectWithValue(error.response?.data || 'Error verifying OTP');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const GetZoomcallback = createAsyncThunk(
    'kyc/GetZoomcallback',
    async (authCode, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.get(`${zoomurl}ZoomAuth/ZoomCallback?code=${authCode}`, { headers });
            
            return response.data; // Return the response data to be handled in extraReducers 
        } catch (error) {
            
            return rejectWithValue(error.response?.data || 'Error during Zoom callback');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const validateBankDetails = createAsyncThunk(
    'kyc/validateBankDetails',
    async (bankDetails, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.post(`${kycbaseurl}Kyc/ValidateBankDetails`, bankDetails);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error validating bank details');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const updateKycDetails = createAsyncThunk(
    "kyc/updateKycDetails",
    async ({payload,doctorId}, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.patch(
                `${kycbaseurl}Kyc/AdminUpdateDoctorKyc?doctorId=${doctorId}`,
                payload,
                {
                    headers: {
                        ...headers, 
                        "Content-Type": "application/json", 
                    },
                }
            );
            
            return response.data;
        } catch (error) {
            console.error("Error updating KYC details:", error.response?.data);
            return rejectWithValue(error.response?.data || "Error updating KYC details");
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const refreshKycStatus = createAsyncThunk(
    'kyc/refreshKycStatus',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoading(true));
            
            const response = await axios.get(`${kycbaseurl}Auth/RefreshToken`, { headers });
            const decodedToken = jwtDecode(response.data?.Token);
            
            if (decodedToken.KycStatus === 'Completed') {
                localStorage.setItem('accessToken',response.data?.Token)
                return true; 
            } else {
                return false; 
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Error fetching details');
        } finally {
            dispatch(setLoading(false));
        }
    }
);

const hrKycSlice = createSlice({
    name: 'managehrkyc',
    initialState,
    reducers: {
        setActiveSection: (state, action) => {
            state.activeSection = action.payload;
        },
        setPayoutDetails: (state, action) => {
            state.payouts = { ...state.payouts, ...action.payload };
        },
        setProfilePic: (state, action) => {
            state.profile.profilePic = action.payload;
        },
        setIdProof: (state, action) => {
            state.profile.idproof = action.payload;
        },
        setIdProofType: (state, action) => {
            state.profile.idprooftype = action.payload;
        },
        setEmail: (state, action) => {
            state.profile.email = action.payload;
        },
        setDob: (state, action) => {
            state.profile.dob = action.payload;
        },
        setGender: (state, action) => {
            state.profile.gender = action.payload;
        },
        setTitle: (state, action) => {
            state.profile.title = action.payload;
        },
        setLegalName: (state, action) => {
            state.profile.legalName = action.payload;
        },
        setAddress: (state, action) => {
            state.profile.address = action.payload;
        },
        addSpecialization: (state, action) => {
            state.specialization.push(action.payload);
        },
        addEducation: (state, action) => {
            state.education.push(action.payload);
        },
        removeSpecialization: (state, action) => {
            state.specialization = state.specialization.filter(
                (_, index) => index !== action.payload
            );
        }, 
        removeEducation:(state,action)=>{
            state.education=state.education.filter(
                (_, index) => index !== action.payload
            );
        }, 
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDoctorDetails.fulfilled, (state, action) => {
                const data = action.payload;
                state.profile = {
                    name: data.Name,
                    address: data.Address,
                    dob: data.Dob,
                    userName: data.UserName,
                    email: data.Email,
                    phoneNumber: data.PhoneNumber,
                    profilePic: data.ProfilePic,
                    gender: data.Gender,
                    title: data.Title,
                    idprooftype: data.IdProofType,
                    idproof: data.IdProof,
                    coutryCode:data.CountryCode,
                        legalName: data.LegalName || data.Name || ''   // <-- add this

                };
                state.education = data.EducationalQualifications;
                state.specialization = data.DoctorSpecializations;
                state.payouts = data.BankDetails;
                state.zoom = data.MeetingLink;
                state.doctordetails=data;
            })
            // No need for a specific rejected case for 403, as it's handled in the component.
            // .addCase(getDoctorDetails.rejected, (state, action) => {
            //     // Optional: Handle other error scenarios if needed
            // })
            .addCase(getAuthorities.fulfilled, (state, action) => {
                state.authoritymaster = action.payload; 
            })
            .addCase(validateBankDetails.fulfilled, (state, action) => {
                state.payouts = { ...state.payouts, ...action.payload };
            })
            .addCase(validateBankDetails.rejected, (state, action) => {
                console.error('Bank details validation failed:', action.payload);
            })
            .addCase(GetZoomcallback.fulfilled, (state, action) => {
                if (action.payload.Success) {
                    state.zoom = action.payload; 
                    state.iszoomauthvalidated = true; 
                } else {
                    console.error('Zoom callback failed:', action.payload.Message);
                }
            })
            .addCase(GetZoomcallback.rejected, (state, action) => {
                console.error('Zoom callback error:', action.payload);
            })
            .addCase(updateKycDetails.fulfilled, (state, action) => {
                
            })
            .addCase(updateKycDetails.rejected, (state, action) => {
                console.error("KYC details update failed:", action.payload);
            });
             
    },
});
export const { setActiveSection,setAddress, setPayoutDetails, setProfilePic ,setIdProof, 
    setIdProofType, setEmail, setDob, setGender, setTitle, setLegalName ,addSpecialization,addEducation,removeSpecialization,removeEducation} = hrKycSlice.actions;
export default hrKycSlice.reducer;